;(function () {
  'use strict'

  angular
    .module('contrast.trace.events')
    .controller('csTraceEventRowCtrl', csTraceEventRowCtrl)

  function csTraceEventRowCtrl(
    $translate,
    traceEventsService,
    traceEventTypeToClassService,
    traceCommonRenderService,
    LanguagesService,
    logger,
    TRACE_EVENT_TYPE,
    AuthService
  ) {
    'ngInject'

    var vm, codeLinesLimit, dataViewLinesTruncate

    var translGlobal = {}

    var loaded
    var collapsed

    this.$onInit = function () {
      vm = this
      codeLinesLimit = 3
      dataViewLinesTruncate = 256

      translGlobal = {
        title_events_allCodeStackTrace: $translate.instant(
          'title_events_allCodeStackTrace'
        ),
        title_events_libraryCodeStackTrace: $translate.instant(
          'title_events_libraryCodeStackTrace'
        ),
        title_events_customCodeStackTrace: $translate.instant(
          'title_events_customCodeStackTrace'
        ),
        detail_events_stackTraceCopied: $translate.instant(
          'detail_events_stackTraceCopied'
        )
      }

      angular.extend(vm, {
        codeSelected: {},
        codeSelectOptions: [
          { name: translGlobal.title_events_allCodeStackTrace, value: 'all' },
          {
            name: translGlobal.title_events_libraryCodeStackTrace,
            value: 'lib'
          },
          {
            name: translGlobal.title_events_customCodeStackTrace,
            value: 'custom'
          }
        ]
      })

      angular.extend(vm, {
        onToggle: onToggle,
        isRowCollapsed: isRowCollapsed,
        traceEventHover: traceEventHover,
        getDescription: getDescription,
        getExtraDetails: getExtraDetails,
        getTypeClass: getTypeClass,
        getDetails: getDetails,
        hasStacktraces: hasStacktraces,
        getStacktraceStr: getStacktraceStr,
        getStacktraces: getStacktraces,
        getTotalStacktraces: getTotalStacktraces,
        getLastCustomFrame: getLastCustomFrame,
        getParameters: getParameters,
        hasParameters: hasParameters,
        isLoaded: isLoaded,
        isEventTypeTag: isEventTypeTag,
        isValidEventApi: isValidEventApi,
        showAllStacktraces: showAllStacktraces,
        showLessStacktraces: showLessStacktraces,
        getFrameClass: getFrameClass,
        logCopyValueSuccess: logCopyValueSuccess,
        getCollapsedEvents: getCollapsedEvents,
        hasCollapsedEvents: hasCollapsedEvents,
        showFrame: showFrame,
        getDupesValue: getDupesValue,
        getCodeLinesLimit: getCodeLinesLimit,
        showDupesPlaceholder: showDupesPlaceholder,
        getDataViewLinesTruncate: getDataViewLinesTruncate,
        showClassMethod: showClassMethod,
        showClass: showClass,
        showMethod: showMethod,
        showObject: showObject,
        showReturn: showReturn,
        getTotalChildren: getTotalChildren,
        isAdminPortal: isAdminPortal,
        addSecurityControl: addSecurityControl,
        isGoLanguage: isGoLanguage
      })

      init()
    }

    function init() {
      vm.model = {
        dataView: {
          lines: vm.event.dataView.lines,
          nested: false
        }
      }
      loaded = false
      collapsed = true
      vm.codeSelected = vm.codeSelectOptions[0]
      _createNestedViews()
    }

    function _createNestedViews() {
      if (vm.event.dataView.nested) {
        vm.model.dataView.nested = true
        vm.model.dataView.lines = _createNestedLinesView(
          vm.event.dataView.lines
        )
      }
    }

    function _createNestedLinesView(lines) {
      var first = angular.copy(lines[0]),
        last = first,
        len = lines.length,
        i,
        child
      for (i = 1; i < len; i++) {
        child = angular.copy(lines[i])
        last.children = [child]
        last = child
      }
      return [first]
    }

    function onToggle() {
      collapsed = !collapsed

      if (!loaded) {
        loadEventDetails()
      }
    }

    function loadEventDetails() {
      if (!hasCollapsedEvents()) {
        traceEventsService
          .getEventDetails(vm.event.traceUuid, vm.event.id)
          .then(function (eventDetails) {
            vm.event.details = eventDetails
            loaded = true
          })
          .then(buildStacktraceString)
      }
    }

    function isRowCollapsed() {
      return collapsed
    }

    function buildStacktraceString() {
      var event = vm.event
      if (
        event.details &&
        event.details.stacktraces &&
        angular.isArray(event.details.stacktraces)
      ) {
        event.details.stacktraces[0].isFirstElement = true
        event.stackStr = event.details.stacktraces
          .map(function (stack) {
            return stack.description
          })
          .join('\n')
      }
    }

    // TODO:FakeNews CONTRAST-16436 will update this when working on communication with visualization
    function traceEventHover() {}

    function getDescription() {
      return vm.event.description
    }

    function getExtraDetails() {
      return vm.event.extraDetails
    }

    function getType() {
      return vm.event.type
    }

    function getTypeClass() {
      var c = traceEventTypeToClassService.get(getType())
      if (isRowCollapsed()) {
        return c + ' trace-event-type-collapsed'
      }
      return c
    }

    function getDetails() {
      return vm.event.details
    }

    function getStacktraces() {
      return vm.event.details.stacktraces
    }

    function getStacktraceStr() {
      return vm.event.stackStr
    }

    function getTotalStacktraces() {
      return getStacktraces().length
    }

    function hasStacktraces() {
      return getTotalStacktraces() > 0
    }

    function getLastCustomFrame() {
      return vm.event.details.last_custom_frame
    }

    function getParameters() {
      return vm.event.details.parameters
    }

    function hasParameters() {
      const params = getParameters()
      return Array.isArray(params) ? params.length > 0 : false
    }

    function isLoaded() {
      return loaded
    }

    function isEventTypeTag() {
      return vm.event.type === TRACE_EVENT_TYPE.TAG
    }

    function isValidEventApi() {
      const api = traceEventsService.getEventApi(vm.event)
      return api.includes('java.lang.String')
    }

    function showAllStacktraces() {
      return traceCommonRenderService.showAllStacktraces(vm.event)
    }

    function showLessStacktraces() {
      return traceCommonRenderService.showLessStacktraces(vm.event)
    }

    function getFrameClass(type, isFirst) {
      if (isFirst) {
        return 'frame-sink'
      }
      return 'frame-' + type
    }

    function logCopyValueSuccess() {
      logger.logSuccess(translGlobal.detail_events_stackTraceCopied)
    }

    function getCollapsedEvents() {
      return vm.event.collapsedEvents
    }

    function hasCollapsedEvents() {
      var v = getCollapsedEvents()
      return angular.isArray(v) && v.length > 0
    }

    function showFrame(frame) {
      var selected = vm.codeSelected.value
      var type = frame.type

      if (selected === 'all') {
        return true
      } else if (selected === 'custom' && type === 'custom') {
        return true
      } else if (selected === 'lib' && (type === 'sink' || type !== 'custom')) {
        return true
      }

      return false
    }

    function getTotalChildren() {
      return hasCollapsedEvents() ? getCollapsedEvents().length : 0
    }

    function getDupesValue() {
      return angular.isNumber(vm.event.dupes) && vm.event.dupes > 0
        ? 'x' + vm.event.dupes
        : 0
    }

    function showDupesPlaceholder() {
      return !angular.isNumber(vm.event.dupes) || vm.event.dupes === 0
        ? true
        : undefined
    }

    function getCodeLinesLimit() {
      return codeLinesLimit
    }

    function getDataViewLinesTruncate() {
      return dataViewLinesTruncate
    }

    function showClassMethod() {
      return angular.isDefined(vm.event.details.class)
    }

    function showClass() {
      return angular.isDefined(vm.event.details.class)
    }

    function showMethod() {
      return angular.isDefined(vm.event.details.method)
    }

    function showObject() {
      return angular.isDefined(vm.event.details.object)
    }

    function showReturn() {
      return angular.isDefined(vm.event.details.return)
    }

    function isAdminPortal() {
      return AuthService.isAdminPortal()
    }

    function addSecurityControl(event) {
      if (!AuthService.isAdminPortal()) {
        return traceEventsService.addSecurityControl(event)
      }
    }

    function isGoLanguage() {
      return LanguagesService.isGo(vm.event.traceLanguage)
    }
  }
})()
